import React, { FC, ReactNode, useEffect } from 'react';
import './EditModal.css';
import eFormType from '../../../assets/enums/eFormType';
import { useTranslation } from 'react-i18next';

type EMVariant = 'default' | 'danger' | 'success' | 'warning';

interface Props {
  tempProduct?: any;
  closeModal: () => void;
  setIsModalOpen: (val: boolean) => void;
  hideApproveButton?: boolean;
  modalType: eFormType;
  onSubmitData: () => void;
  title: string;
  width?: string;
  height?: string;
  children: ReactNode;
  variant?: EMVariant;
  overlayClassName?: string;
  containerClassName?: string;
}

const EditModal: FC<Props> = ({
  closeModal,
  setIsModalOpen,
  hideApproveButton = false,
  title,
  onSubmitData,
  width,
  height,
  children,
  variant = 'default',
  overlayClassName = '',
  containerClassName = '',
}) => {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsModalOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [setIsModalOpen]);

  const { i18n } = useTranslation();

  return (
    <div className={`emOverlay ${overlayClassName}`.trim()} onClick={closeModal} role="dialog" aria-modal="true">
      <div
        onClick={(e) => e.stopPropagation()}
        className={`emContainer is-${variant} ${containerClassName}`.trim()}
        style={{
          ...(width ? ({ ['--em-w' as any]: width } as React.CSSProperties) : {}),
          ...(height ? ({ ['--em-h' as any]: height } as React.CSSProperties) : {}),
        }}
      >
        <div className={`emHeader is-${variant}`}>
          <h5 className="emTitle">{title}</h5>
          <button type="button" className="emClose" onClick={() => setIsModalOpen(false)}>
            ✕
          </button>
        </div>

        <div className="emBody">{children}</div>

        <div className="emFooter">
          <button type="button" className="emBtn emBtnGhost" onClick={() => setIsModalOpen(false)}>
            {i18n.t('buttons.cancel')}
          </button>
          {!hideApproveButton &&
          <button type="button" className="emBtn emBtnPrimary" onClick={onSubmitData}>
            {i18n.t('buttons.approve')}
          </button>
          }
        </div>
      </div>
    </div>
  );
};

export default EditModal;
